import React from "react";

import { ApplicationBarNavigation } from "@impero-com/common/components/applicationBar/applicationBar";
import { LoggedInHTTPError } from "@impero-com/common/errorPages/loggedInHTTPError";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { TableRestore } from "@impero-com/ui/domain";
import { useParams } from "react-router-dom";

import { useTestingProgramQuery } from "org/controlTesting/testingProgram/view/queries/useTestingProgramQuery";
import {
    buildTestingActivityListRestoreConfig,
    buildTestingProgramTestingControlsListUrl,
    testingProgramIdParamSchema,
    testingProgramListUrl,
} from "org/controlTesting/urlUtils";

import { OrgApplicationBar } from "../../../../components/applicationBar/orgApplicationBar";

import { TestingActivityListForTestingProgramView } from "./TestingActivityForTestingProgramListView";

export function TestingActivitiesListForProgramPage() {
    const { id: unparsedActivityId } = useParams();
    const programIdParseResult =
        testingProgramIdParamSchema.safeParse(unparsedActivityId);
    if (programIdParseResult.success === false) {
        console.error("Testing program id parse failed:", unparsedActivityId);
        return <LoggedInHTTPError code={400} />;
    }

    const testingProgramId = programIdParseResult.data;
    return (
        <TableRestore
            config={buildTestingActivityListRestoreConfig(testingProgramId)}
        >
            <TestingActivityListAppBar testingProgramId={testingProgramId}>
                <TestingActivityListForTestingProgramView
                    testingProgramId={testingProgramId}
                />
            </TestingActivityListAppBar>
        </TableRestore>
    );
}

interface TestingActivityListAppBarProps {
    children: React.ReactNode;
    testingProgramId: number;
    navigation?: ApplicationBarNavigation;
}
function TestingActivityListAppBar({
    children,
    testingProgramId,
    navigation,
}: TestingActivityListAppBarProps) {
    const { t } = useTranslation();
    const { data } = useTestingProgramQuery(testingProgramId);
    return (
        <OrgApplicationBar
            title={{
                breadCrumbs: [
                    {
                        label: t("ControlTesting_ModuleTitle"),
                        url: testingProgramListUrl,
                    },
                    {
                        label: data.content.resource.name,
                        url: buildTestingProgramTestingControlsListUrl(
                            testingProgramId
                        ),
                    },
                ],
                title: t("ControlTestingActivityList_Title"),
            }}
            navigation={navigation}
        >
            {children}
        </OrgApplicationBar>
    );
}
